import { useContext } from 'react';
import { DeleteForeverOutlined } from '@mui/icons-material';

import ActionItem from '../utils/tableActionTrigger';
import { LocalesContext } from '../../localesContext';
import { CanceledReport, HandleOpenCancelDialog } from './interfaces';

interface Props {
  item: CanceledReport;
  handleOpenCancelDialog: HandleOpenCancelDialog;
}

const CancelReportTableActionTrigger = ({ item, handleOpenCancelDialog }: Props) => {
  const locales = useContext(LocalesContext);

  return (
    <ActionItem onClick={() => handleOpenCancelDialog(item)} item={item} tooltip={locales.tooltip.cancel}>
      <DeleteForeverOutlined cursor="pointer" />
    </ActionItem>
  );
};

export default CancelReportTableActionTrigger;
